import {
  CommandDialogRoot,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandLoading,
  CommandRoot,
  CommandSeparator,
  CommandShortcut,
} from './cmdk.parts';

/**
 * Anatomy -
 *
 * <Command.Root>  // or <Command.DialogRoot>
 *  <Command.Input placeholder="Type a command or search"/>
 *  <Command.List>
 *   <Command.Empty>No results found.</Command.Empty>
 *   <Command.Group heading="Chat related">
 *    <Command.Item>Search Emoji<Command.Shortcut>⌘E</Command.Shortcut></Command.Item>
 *    <Command.Item/>
 *   </Command.Group>
 *   <Command.Separator />
 *   <Command.Group>
 *    <Command.Item />
 *   </Command.Group>
 * </Command.List>
 * </Command.Root>
 */
export const Command = {
  Root: CommandRoot,
  DialogRoot: CommandDialogRoot,
  Input: CommandInput,
  List: CommandList,
  Loading: CommandLoading,
  Empty: CommandEmpty,
  Group: CommandGroup,
  Item: CommandItem,
  Shortcut: CommandShortcut,
  Separator: CommandSeparator,
};
